import React from 'react'
import IconBase from 'components/atoms/IconBase/IconBase'

interface Props {
  idVariant?: string
  className?: string
}

function Leaf({ idVariant = '', className }: Props) {
  return (
    <IconBase name="leaf" w={80} className={className}>
      <path
        d="M36.8401 54.7133C31.1066 54.7133 25.9312 52.664 22.2336 48.9664C18.6407 45.3735 16.9537 40.0077 17.1647 34.5226C17.3756 29.0399 19.4817 23.4989 23.3936 19.5802C31.9777 10.9961 45.4386 9.16667 55.3067 9.16667C58.9651 9.16667 61.8353 9.43643 63.2057 9.58622C63.4668 11.7928 64.0064 17.9538 63.0081 25.2068C61.9424 32.9493 59.1323 41.8806 52.4199 48.5931C48.5359 52.4771 42.8673 54.7133 36.8534 54.7133H36.8401Z"
        stroke="currentColor"
      />
      <path
        d="M19.8532 73.4801C19.8532 73.4801 18.5199 46.8135 43.8532 28.1468"
        stroke="#BD1622"
        strokeMiterlimit="10"
      />
    </IconBase>
  )
}

export default Leaf
